// extracted by mini-css-extract-plugin
export var bd = "c_y";
export var bigger = "c_C";
export var detail = "c_B";
export var downloadBar = "c_x";
export var footBottom = "c_w";
export var footBottomDesc = "c_F";
export var footLine = "c_t";
export var footTop = "c_q";
export var footTopAddress = "c_v";
export var footTopDesc = "c_r";
export var footTopText = "c_s";
export var footerM = "c_p";
export var ft = "c_G";
export var logo = "c_z";
export var minWidthLimit = "c_b";
export var red = "c_D";